/**
 * SolutionsInstitutionsHero — the `/solutions/institutions` design.
 *
 * Verbatim render of `solutions-institutions.html`. Modules in
 * ./landing/solutions-institutions/. Real app routes + in-page anchors
 * are wired through `wireLinks={true}` (see PageHost for the click
 * dispatcher).
 */
import { STYLES } from "./landing/solutions-institutions/styles";
import { MARKUP } from "./landing/solutions-institutions/markup";
import { SCRIPT } from "./landing/solutions-institutions/script";
import { PageHost } from "./landing/PageHost";

export function SolutionsInstitutionsHero() {
  return (
    <PageHost
      styles={STYLES}
      markup={MARKUP}
      script={SCRIPT}
      hostClass="trex-institutions-host"
      wireLinks={true}
      data-testid="solutions-institutions-hero"
    />
  );
}
